import http from '@/axios/http'
import { getuser_id, getclient_user_id, getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";

//分组列表
export function getGroupList(offset, limit,pid=0) {
    const data={
        user_id: getuser_id(),
        client_user_id: getclient_user_id(),
        offset: offset,
        limit: limit,
        pid
    }
    return http({
        url: '/api/device/getGroupList',
        method: 'post',
        data
    })
}

//新增分组
export function addGroup(groupName, level, parentGroupId, cid = null, superlink, uid = null) {
    const data = {
        groupName: groupName,
        level: level,
        parentGroupId: parentGroupId,
        cid: cid,
        // superlink: superlink,
        uid: uid
    }
    return http({
        url: '/api/device/addGroup',
        method: 'post',
        data
    })
}

//修改分组
export function modifyGroupName(gid, groupName, level, parentGroupId, uid = null, cid, superlink,
    name = null, password = null, ip = null, loginType, LoginNum,n2nInfoBridge = 0,n2nIfnoMaskbit = undefined) {
    console.log(loginType)
    const data = {
        gid: gid,
        groupName: groupName,
        level: level,
        parentGroupId: parentGroupId,
        uid: uid,
        cid: cid,
        // superlink: superlink,
        name: name,
        password: password,
        ip: ip,
        loginType: loginType,
        loginNum: LoginNum,
        n2nInfoBridge,
        n2nIfnoMaskbit
    }
    return http({
        url: '/api/device/modifyGroupName',
        method: 'post',
        data
    })
}

//删除分组
export function deleteGroup(groupId) {
    const data = {
        user_id: getuser_id(),
        groupId: groupId
    }
    return http({
        url: '/api/device/deleteGroup',
        method: 'post',
        data
    })
}

//获取客户列表
export function getCustomerList() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999
    }
    return http({
        url: '/api/customer/getCustomerList',
        method: 'post',
        data
    })
}
//获取用户列表
export function getUserList() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999
    }
    return http({
        url: '/api/user/getUserList',
        method: 'post',
        data
    })
}
//获取三级分组
export function getAddLevel3Group(pid) {
    return http({
        url: '/api/device/getAddLevelGroup',
        method: 'post',
        data:{pid}
    })
}
//查询分组
export function queryGroupKeyword(keyword, offset, limit, sort,groLevel) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        groupname: sort.groupname, //分组名
        parentname: sort.parentname, //上级分组
        cname: sort.cname, //归属客户/归属用户
        create: sort.create, //创建者
        superlink: sort.superlink, //服务类型
        account: sort.account, //远程账号
        password: sort.password, //远程密码
        ip: sort.ip, //远程ip
        updatetime: sort.updatetime, //更新时间
        pid:0,
        groLevel//查询分组级别
    }
    return http({
        url: '/api/device/queryGroupKeyword',
        method: 'post',
        data
    })
}
//获取n2n分组
export function GetListN2nServer(offset = 1, limit = 10) {
    const data = {
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/n2nServer/listN2nServer',
        method: 'post',
        data
    })
}
//迁移服务
export function updateGroupInfo(n2nInfoIds, serverId, port) {
    const data = {
        n2nInfoIds,
        serverId,
        port
    }
    return http({
        url: '/api/n2nServer/updateGroupInfo',
        method: 'post',
        data
    })
}


// 根据客户id查询一级分组
export function getByCustomer(cid) {
  return http({
    url: '/api/group/cid/list',
    method: 'post',
    data: {
      cid,
    }
  })
}
// 根据用户id查询一级分组
export function getByUser(uid) {
  return http({
    url: '/api/group/uid/list',
    method: 'post',
    data: {
      uid,
    }
  })
}

// 编辑时获取分组详情
export function getDetail(data) {
  return http({
    url: '/api/group/detail',
    method: 'post',
    data,
  })
}

// 获取n2n版本
export function getN2nVersion(data) {
  return http({
    url: '/api/n2nServer/getN2nServer',
    method: 'post',
    data
  })
}